import { ToastService } from "@shared/lib/services";
import { IInfluencerContact } from "@shared/lib/types/briefInfluencerV2";
import { Flex, Space, Tag, Tooltip, Typography } from "antd";
import { Copy, Mail, Phone } from "lucide-react";
import { TextWithTooltip } from "../TextWithTooltip";
import styles from "./CreatorContactDetails.module.scss";

interface CreatorContactDetailsProps {
  contact?: IInfluencerContact;
  isContactAdded: boolean;
  isCompact?: boolean;
}

export default function CreatorContactDetails({
  contact,
  isContactAdded,
  isCompact = false,
}: CreatorContactDetailsProps) {
  if (!isContactAdded) {
    return (
      <Typography.Text className={styles.pendingText}>
        No Contact
      </Typography.Text>
    );
  }

  const hasAgencyUser = !!contact?.agencyUser;
  const phoneNumber = hasAgencyUser
    ? contact?.agencyUser?.phoneNumber
      ? `${contact?.agencyUser?.countryCode || ""} ${contact?.agencyUser?.phoneNumber}`.trim()
      : ""
    : contact?.phoneNumber
      ? `${contact?.countryCode || ""} ${contact?.phoneNumber}`.trim()
      : "";

  const emailId = hasAgencyUser
    ? contact?.agencyUser?.emailId || ""
    : contact?.emailId || "";

  const agencyName = contact?.agency?.name || "";
  const agencyPic = contact?.agency?.profilePicUrl || "";
  const creatorName = contact?.name || "";

  return (
    <Flex vertical gap={4}>
      <Flex vertical={!isCompact} gap={isCompact ? 10 : 4}>
        {/* Line 1: Phone */}
        <Flex align="center" gap={5}>
          {isCompact ? (
            <Tooltip title={phoneNumber}>
              <Phone
                size={12}
                style={{
                  cursor: "pointer",
                  color: "#8c8c8c",
                  flexShrink: 0,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(phoneNumber);
                  ToastService.success("Copied to clipboard");
                }}
              />
            </Tooltip>
          ) : (
            //
            <>
              <Phone size={12} style={{ color: "#8c8c8c", flexShrink: 0 }} />
              <TextWithTooltip
                text={phoneNumber || "—"}
                textClassName={styles.contactValueText}
                limit={50}
                // limit={18}
              />
              {phoneNumber && (
                <Tooltip title="Copy phone number">
                  <Copy
                    size={12}
                    style={{
                      cursor: "pointer",
                      color: "#8c8c8c",
                      flexShrink: 0,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(phoneNumber);
                      ToastService.success("Copied to clipboard");
                    }}
                  />
                </Tooltip>
              )}
            </>
          )}

          {/* <Phone size={12} style={{ color: "#8c8c8c", flexShrink: 0 }} /> */}
        </Flex>

        {/* Line 2: Mail */}
        <Flex align="center" gap={5}>
          {isCompact ? (
            <Tooltip title={emailId}>
              <Mail
                size={12}
                style={{
                  cursor: "pointer",
                  color: "#8c8c8c",
                  flexShrink: 0,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(emailId);
                  ToastService.success("Copied to clipboard");
                }}
              />
            </Tooltip>
          ) : (
            <>
              {" "}
              <Mail size={12} style={{ color: "#8c8c8c", flexShrink: 0 }} />
              <TextWithTooltip
                text={emailId || "—"}
                textClassName={styles.contactValueText}
                limit={20}
              />
              {emailId && (
                <Tooltip title="Copy email ID">
                  <Copy
                    size={12}
                    style={{
                      cursor: "pointer",
                      color: "#8c8c8c",
                      flexShrink: 0,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(emailId);
                      ToastService.success("Copied to clipboard");
                    }}
                  />
                </Tooltip>
              )}
            </>
          )}
        </Flex>

        {/* Line 3: Agency/Self Tag containing both type and name */}
      </Flex>
      {hasAgencyUser ? (
        <Tag className={styles.contactTag}>
          <Space align="center" size={2}>
            {/* <span>Agency</span> */}
            {/* <span>·</span> */}
            {/* {agencyPic && (
              <Avatar
                src={agencyPic}
                alt={agencyName}
                size={16}
                style={{ flexShrink: 0 }}
              />
            )} */}
            <TextWithTooltip
              text={agencyName}
              limit={isCompact ? 10 : 100}
              textClassName={styles.contactValueText}
            />
          </Space>
        </Tag>
      ) : (
        <div />
      )}
    </Flex>
  );
}
